module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/sheridan-finley-3f43a61a582554ea1f19ac1d2d3bae16.jpg";